import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { deletePayInfo } from '../../api/orderHistory'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { colorObj } from '../color'
import { InputCheckbox } from '../input/InputCheckbox'
import { PaymentInfoItem } from '../../@types/order'

export default function CardDeleteModal({
  setIsModal,
  cardInfos,
  setChangePayData,
}: {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
  cardInfos: PaymentInfoItem[]
  setChangePayData: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [keyArray, setKeyArray] = useState<string[]>([])

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setIsModal(false)
      setClosing(false)
    }, 280)
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>카드 삭제</p>
          <button onClick={closeModal}>
            <img src='../images/icon_close.png' alt='닫기 버튼' />
          </button>
        </ModalHeader>
        <ModalBody>
          <div className='card_list'>
            <ul>
              {cardInfos?.map((element: any, index: number) => {
                return (
                  <DeleteItem
                    element={element}
                    keyArray={keyArray}
                    setKeyArray={setKeyArray}
                    key={`${index}1`}
                  ></DeleteItem>
                )
              })}
            </ul>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={() => {
              if (keyArray.length === 0) {
                alert('삭제할 카드를 선택해 주세요.')
              } else {
                Promise.all(
                  keyArray.map((el: any) => {
                    return deletePayInfo(el)
                  })
                )
                  .then(() => {
                    alert('삭제되었습니다.')
                  })
                  .catch((err) => {
                    console.log(err)
                  })
                setTimeout(() => {
                  setChangePayData((prev: any) => !prev)
                }, 500)
                closeModal()
              }
            }}
          >
            삭제하기
          </button>
        </ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}

function DeleteItem({ element, keyArray, setKeyArray }: any) {
  const [isCheckbox, setIsCheckbox] = useState<boolean>(false) // 카드삭제 체크박스 상태

  return (
    <li>
      <InputCheckbox
        text={`${element.cardName} (${element.bankCardNo.split('-****-')[1]})`}
        isCheckbox={isCheckbox}
        setIsCheckbox={setIsCheckbox}
        event={() => {
          if (!isCheckbox) {
            setKeyArray((prev: any) => [...prev, element.payToken])
          } else {
            let array: any = []
            keyArray.map((el: any) => {
              if (el === element.payToken) {
                if (keyArray.length === 1) {
                  array = []
                }
              } else {
                array.push(el)
              }
              setKeyArray(array)
            })
          }
        }}
        fontSize={16}
        lineHeight='20px'
        color={isCheckbox ? colorObj.colBlack : colorObj.colGray6}
        fontWeight={isCheckbox ? 600 : 500}
        key={element.id}
      ></InputCheckbox>
    </li>
  )
}

interface typeProps {
  closing?: boolean
}

export const ModalBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 900;
`

export const ModalBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;

  @media screen and (min-width: 768px) {
    width: 480px;
    height: 300px;
    border-radius: 10px;
    animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
    position: fixed;
    z-index: 30;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18.5px 22px 0 33px;
  align-items: center;
  position: relative;
  & p {
    color: var(--colBlack);
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
  & button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 41px;
    height: 48px;
    border: none;
    background: none;
    cursor: pointer;
    & img {
      width: 24px;
      height: 24px;
    }
  }
  @media screen and (min-width: 768px) {
    padding: 6px 4px 6px 20px;
  }
`

export const ModalBody = styled.div`
  padding: 8px 33px 32px 33px;
  & .card_list {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: var(--colGray6);
    & ul {
      display: flex;
      flex-direction: column;
      gap: 24px;
      & li {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }
  @media screen and (min-width: 768px) {
    flex: 1;
    display: flex;
    min-height: 160px;
    overflow-y: auto;
    padding: 0 20px 0 20px;
    margin-bottom: 10px;
  }
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 33px;
  & button {
    width: 100%;
    height: 48px;
    border: none;
    background: var(--colBlack);
    color: var(--colWhite);
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
  }
  @media screen and (min-width: 768px) {
    padding: 4px 20px 20px 20px;
  }
`

export const CouponBox = styled.div`
  display: flex;
  margin: 8px 20px;
  flex-direction: column;
  gap: 12px;
  max-height: 328px;
  min-height: 129px;
  overflow-y: scroll;
`

export const CouponItem = styled.div``

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`
export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0 160px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`

export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
